import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { RecipesComponent } from '../../recipes/recipes.component';
import { CloseConfirmComponent } from '../../close-confirm/close-confirm.component';

@Component({
  selector: 'vex-edit-thropy',
  templateUrl: './edit-thropy.component.html',
  styleUrls: ['./edit-thropy.component.scss']
})
export class EditThropyComponent implements OnInit {
  iconFormFlag: any;
  flags = {
    en: 'flag:united-states',
    it: 'flag:italy'
  };
  currentLang: string;
  formLang: any;
  ngForm: any = {
    i18nTitle: {
      "EN": "",
      "IT": ""
    },
    i18nDescription: {
      "EN": "",
      "IT": ""
    },
    draft: false,
    type: ""
  }

  types = [
    {
      key: "workout",
      description: "workout"
    },
    {
      key: "consistency",
      description: "consistency"
    },
    {
      key: "programs",
      description: "programs"
    },
    {
      key: "challenges",
      description: "challenges"
    },
    {
      key: "fullWeeks",
      description: "fullWeeks"
    },
    {
      key: "workoutInWeeks",
      description: "workoutInWeeks"
    }
  ]

  programs = [];

  challenges = [];

  constructor(@Inject(MAT_DIALOG_DATA) private item: any['item'], public translate: TranslateService, public guiService: GuiService, public restService: RestService, private dialogRef: MatDialogRef<RecipesComponent>, public dialog: MatDialog) {
    this.currentLang = translate.currentLang || translate.getDefaultLang();
  }

  ngOnInit(): void {
    this.getPrograms();
    this.getTimeChallenges();
    this.changeFormLanguage(this.translate.currentLang);
    this.ngForm = this.item;
  }

  changeFormLanguage(lang) {
    this.iconFormFlag = this.flags[lang];
    this.formLang = lang;
  }

  getTimeChallenges() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    const param = {
      page: 1,
      size: 30,
      userId: this.guiService.userLogged.user.id
    };
    this.restService.postService('node', '/get-time-challenges', param).subscribe((ris) => {
      this.challenges = ris.items;
      this.guiService.showSpinner = false;
    })
  }

  getPrograms() {
    setTimeout(() => this.guiService.showSpinner = true, 0)
    this.restService.postService('workout_programs', '/search', { page: 0, size: 10 }).subscribe((ris) => {
      this.programs = ris["items"];
      this.guiService.showSpinner = false
    })
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }

  isFormInvalid(): boolean {
  const titleIt = this.ngForm?.i18nTitle?.['IT'];
  const titleEn = this.ngForm?.i18nTitle?.['EN'];
  const descriptionIt = this.ngForm?.i18nDescription?.['IT'];
  const descriptionEn = this.ngForm?.i18nDescription?.['EN'];

  const type = this.ngForm?.type;

  if (!titleIt?.trim()) return true;
  if (!titleEn?.trim()) return true;

  if (!descriptionIt?.trim()) return true;
  if (!descriptionEn?.trim()) return true;

  if (!type) return true;

  if (type === 'workout' && !this.ngForm?.workoutAmount) return true;
  if (type === 'consistency' && !this.ngForm?.consistencyMonths) return true;
  if (type === 'challenges' && !this.ngForm?.challengeId?.trim()) return true;
  if (type === 'fullWeeks' && !this.ngForm?.programWeekNumber) return true;

  if (type === 'programs') {
    if (!this.ngForm?.programId?.trim()) return true;
    if (!this.ngForm?.programWorkoutNumber) return true;
    if (!this.ngForm?.programWeekNumber) return true;
  }

  if (type === 'workoutInWeeks') {
    if (!this.ngForm?.programWorkoutNumber) return true;
    if (!this.ngForm?.programWeekNumber) return true;
  }

  return false;
}


  submit(){
    console.debug(this.ngForm);
    this.restService.postServiceUserId('node','/update-trophy',this.ngForm, this.guiService.userLogged.user.id).subscribe((ris)=>{
      this.dialogRef.close('done');
    })
  }

}
